import { getInterviewTimeValidationError } from 'features/sendouts/components/drawers/CreateSendoutDrawer/CreateSendoutDrawer.utils';
import { FORM_FIELDS_MAP } from 'features/sendouts/components/drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';
import {
  buildSendoutInterviewDefaultValues,
  buildSendoutInterviewPayload
} from 'features/sendouts/components/forms/SendoutInterviewForm';
import { INTERVIEW_CALL_TYPES } from 'features/sendouts/constants/constants';
import { formatDefaultValues } from 'UI/components/organisms/InterviewDetailsDrawer/utils';
import { Endpoints } from 'UI/constants/endpoints';

import { TAB_IDS } from './SendoutInterviewDrawer.constants';

const validateInterviewTime = ({ clearError, formData, setError }) => {
  const interviewTimeValidationError = getInterviewTimeValidationError(formData);

  if (interviewTimeValidationError) {
    setError(
      interviewTimeValidationError.fieldKey,
      'validate',
      interviewTimeValidationError.message
    );
    return false;
  }

  clearError(FORM_FIELDS_MAP.InterviewFromHour.key);
  clearError(FORM_FIELDS_MAP.InterviewToHour.key);
  return true;
};

const buildCallConfig = ({ callType, endpoint }) => ({
  endpoint,
  buildDefaultValues: record => formatDefaultValues({ data: record }),
  buildSubmitArgs: (formData, { existingItemId }) => ({
    callType,
    existingItemId,
    payload: formData
  })
});

export const INTERVIEW_TAB_CONFIG = {
  [TAB_IDS.InterviewDetails]: {
    endpoint: Endpoints.SendoutInterviewDetails,
    buildDefaultValues: record => buildSendoutInterviewDefaultValues(record),
    buildSubmitArgs: formData => ({ payload: buildSendoutInterviewPayload(formData) }),
    validate: validateInterviewTime
  },
  [TAB_IDS.PreparationCall]: buildCallConfig({
    callType: INTERVIEW_CALL_TYPES.Preparation,
    endpoint: Endpoints.SendoutPreparationCalls
  }),
  [TAB_IDS.DebriefingCall]: buildCallConfig({
    callType: INTERVIEW_CALL_TYPES.Debriefing,
    endpoint: Endpoints.SendoutDebriefingCalls
  })
};
